import request from '@/utils/request.js'

// 获取路由
export const getRouters = () => {
  return request({
    url: process.env.VUE_APP_RUOYI_API+'/getRouters',
    method: 'get'
  })
}

// 获取路由
export const getDefaultRouters = () => {
  return request({
    url: process.env.VUE_APP_RUOYI_API+'/default/routers',
    method: 'get'
  })
}